import {useSyncExternalStore} from 'react';

export interface AccountDeletion {
    deletionRequestedAtUtc: string | null;
    scheduledDeletionAtUtc: string | null;
    isReadOnly: boolean;
}

const active: AccountDeletion = {deletionRequestedAtUtc: null, scheduledDeletionAtUtc: null, isReadOnly: false};
let state = active;
let revision = 0;
export const getAccountDeletionRevision = () => revision;
const listeners = new Set<() => void>();
export const getAccountDeletion = () => state;
export function setAccountDeletion(next: AccountDeletion) {
    const normalized = {deletionRequestedAtUtc: next.deletionRequestedAtUtc ?? null,
        scheduledDeletionAtUtc: next.scheduledDeletionAtUtc ?? null, isReadOnly: next.isReadOnly};
    if (JSON.stringify(state) === JSON.stringify(normalized)) return;
    revision++;
    state = normalized;
    listeners.forEach(listener => listener());
}
export const resetAccountDeletion = () => setAccountDeletion(active);
export const useAccountDeletion = () => useSyncExternalStore(listener => {
    listeners.add(listener);
    return () => { listeners.delete(listener); };
}, getAccountDeletion);

// Search uses POST in the existing customer API; it remains available in read-only mode.
export const canRequestInReadOnly = (endpoint: string, method: string) =>
    ['GET', 'HEAD', 'OPTIONS'].includes(method.toUpperCase()) ||
    ['logOut', 'logIn', 'searchCustomersV2', 'cancelAccountDeletion'].includes(endpoint);
